import Vue from 'vue'
import VueI18n from 'vue-i18n';
import zhLocale from "./zh.js";
import enLocale from "./en.js";
import * as GLOBAL from "../../components/Global.js"

Vue.use(VueI18n);

// const locales = {
//   [GLOBAL.LANG.EN]: require('./en.js'),
//   [GLOBAL.LANG.ZH]: require('./zh.js'),
// };

const i18n = new VueI18n({
  locale: GLOBAL.DEFAULT_LANG,
  messages: {
    [GLOBAL.LANG.EN]: enLocale,
    [GLOBAL.LANG.ZH]: zhLocale,
  }
});

export const setup = lang => {
  // let language = navigator.language || navigator.userLanguage;
  // language = language.substr(0, 2);
  // if (language === undefined) {
  //   lang = DEFAULT_LANG;
  // } else if (language === 'en') {
  //   lang = DEFAULT_LANG;
  // } else if (language === 'zh') {
  //   lang = 'zh';
  // }
  lang = GLOBAL.DEFAULT_LANG

  if (window.localStorage.getItem(GLOBAL.LOCALE_KEY)) {
    lang = window.localStorage.getItem(GLOBAL.LOCALE_KEY)
  } else {
    window.localStorage.setItem(GLOBAL.LOCALE_KEY, lang);
  }

  // Object.keys(locales).forEach(lang => {
  //   document.body.classList.remove(`lang-${lang}`)
  // })
  // document.body.classList.add(`lang-${lang}`);
  // document.body.setAttribute('lang', lang);

  Vue.config.lang = lang;
  i18n.locale = lang;
}

setup();
export default i18n